import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, Subject } from 'rxjs';

import { environment } from '@environments/environment';


import { UtilitiyService } from './utility.service';

import { DirectoryModel } from '@classes/wiki/directory-model.model';
import { ChangeFileOrder } from '@classes/wiki/change-file-order.model';
import { FileToDelete } from '@classes/wiki/file-to-delete.model';
import { NameAndPath } from '@classes/wiki/name-and-path.model';
import { WikiItem } from '@classes/wiki/wiki-item.model';
import { HtmlFile } from '@classes/wiki/html-file.model';

@Injectable({
    providedIn: 'root'
})
export class FileService  {

    selectedLanguage: string;

    private editorSub = new Subject<NameAndPath>();
    private hasSelectedAFileSub = new BehaviorSubject<boolean>(false);
    private toDeleteSub = new Subject<FileToDelete>();
    private changeFilesLanguageSub = new Subject<string>();
    public providerSub: BehaviorSubject<string>; // = new BehaviorSubject<string>(null);
    private firstPageSub: BehaviorSubject<string> = new BehaviorSubject<string>(null);

    constructor(private httpClient: HttpClient, private utilityService: UtilitiyService) {
        const pv = sessionStorage.getItem(environment.provider);
        this.providerSub = (pv !== null && pv !== '' && pv !== undefined) ? new BehaviorSubject<string>(pv) : new BehaviorSubject<string>(null);
    }

    getDirectoriesAndFiles(provider: string = null): Observable<DirectoryModel> {
        return this.httpClient.get<DirectoryModel>(`${environment.apiUrl}wiki/directories/files?flat=false${provider === null ? '' : `&provider=${provider}`}`);
    }

    // getDirectoriesAndFilesFlat(): Observable<WikiItem[]> {
    //     return this.httpClient.get<WikiItem[]>(`${environment.apiUrl}wiki/directories/files?flat=true`);
    // }

    getLanguages(provider: string = null): Observable<string[]> {
        return this.httpClient.get<string[]>(`${environment.apiUrl}wiki/languages${provider === null ? '' : `?provider=${provider}`}`);
    }

    changeFileOrder(newDirectoryModel: ChangeFileOrder, provider: string = null): Observable<DirectoryModel> {
        return this.httpClient.post<DirectoryModel>(`${environment.apiUrl}wiki/files/order${provider === null ? '' : `?provider=${provider}`}`, newDirectoryModel);
    }

    deleteFileOrFolder(fileToDelete: FileToDelete, provider: string = null): Observable<DirectoryModel> {
        const encrypted = this.utilityService.encryptString(fileToDelete.path);
        if (fileToDelete.isADir) {
            return this.httpClient.delete<DirectoryModel>(`${environment.apiUrl}wiki/directories/${encrypted}${provider === null ? '' : `?provider=${provider}`}`);
        }
        return this.httpClient.delete<DirectoryModel>(`${environment.apiUrl}wiki/files/${encrypted}${provider === null ? '' : `?provider=${provider}`}`);
    }

    getEditorSub(): Observable<NameAndPath> {
        return this.editorSub.asObservable();
    }

    changeEditorSub(article: NameAndPath): void {
        this.editorSub.next(article);
        this.changeHasSelectedAFile(true);
    }

    getHasSelectedAFile(): Observable<boolean> {
        return this.hasSelectedAFileSub.asObservable();
    }

    changeHasSelectedAFile(selected: boolean): void {
        this.hasSelectedAFileSub.next(selected);
    }

    changeToDeleteSub(toDelete: FileToDelete): void {
        this.toDeleteSub.next(toDelete);
    }

    getToDeleteSub(): Observable<FileToDelete> {
        return this.toDeleteSub.asObservable();
    }

    getLanguageTreeSub(): Observable<string> {
        return this.changeFilesLanguageSub;
    }

    changeLanguageTreeSub(lg: string): void {
        this.changeFilesLanguageSub.next(lg);
    }

    getProviderSub(): Observable<string> {
        return this.providerSub;
    }

    changeProviderSub(provider: string): void {
        this.providerSub.next(provider);
    }

    getFirstPageSub(): Observable<string> {
        return this.firstPageSub;
    }

    changeFirstPageSub(provider: string): void {
        this.firstPageSub.next(provider);
    }
}
